<template>
    <div class="posts_sorting_table">
        <div class="lk-popup add_form zone" v-if="button === 'zone'" style="position: fixed;left: 0;right: 0;top: 12%;z-index: 999;" >
            <div class="title">
                <h1 style="display: inline-block;" v-if="!currentZone.id">Добавить зону доставки</h1>
                <h1 style="display: inline-block;" v-else>Редактирование зоны</h1>
                <button class="cross" @click="button = null, currentZone = {}" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div class="dish_form">
                    <div class="info_row">
                        <span class="input_description">Название</span>
                        <input type="text" placeholder="Введите текст" v-model="currentZone.title">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Описание</span>
                        <input type="text" v-model="currentZone.desc">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Стоимость</span>
                        <input type="number" min="0" v-model="currentZone.price">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Минимальная стоимость заказа</span>
                        <input type="number" min="0" v-model="currentZone.min_price">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Бесплатная доставка от</span>
                        <input type="number" min="-1" v-model="currentZone.free_price">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Время доставки</span>
                        <input type="number" min="0" v-model="currentZone.time">
                    </div>

                    <div class="info_row">
                        <span class="input_description">Цвет заливки</span>
                        <input type="color" v-model="currentZone.color">
                    </div>

                    <button id="delete-button">Удалить фигуру</button>
                    <div class="info_row map">
                        <span class="input_description">Зона доставки</span>
                        <div id="main_map" ref="map" style="height: 300px; width: 100%"></div>
                    </div>

                    <button class="menu_item_btn" @click="exportMap">Сохранить</button>

                </div>
            </div>
        </div>

        <div class="toolbar">
            <button @click="button = 'zone'">Добавить</button>
        </div>
        <table class="posts_table" id="posts_menu_table">
            <thead>
            <tr class="row">
                <th>№</th>
                <th>Заголовок</th>
                <th>Описание</th>
                <th>Мин. стоимость заказа</th>
                <th>Цена, руб</th>
                <th>Бесплатная доставка, от</th>
                <th>Время доставки</th>
                <th></th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr class="row" v-for="(zone, index) in zones" :key="index">
                <td class="td">{{zone.id}}</td>
                <td class="td">{{zone.title}}</td>
                <td class="td">{{zone.desc}}</td>
                <td class="td">{{zone.min_price}}</td>
                <td class="td">{{zone.price}}</td>
                <td class="td">{{zone.free_price}}</td>
                <td class="td">{{zone.time}}</td>
                <td class="td">
                    <button class="button edit" @click="(currentZone = zone, zone.radius===null?button = 'zone':button = 'radius')">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/edit.svg" alt="">
                    </button>
                </td>
                <td class="td">
                    <button class="button cancel" @click="deleteZone(zone)">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
export default {
  name: 'zones',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      table: null,
      map: null,
      initAutocompleteInterval: null,
      autocomplete: null,
      bounds: null,
      marker: null,
      newPoly: null,
      drawingManager: null,
      zones: [],
      button: null,
      currentZone: {},
      restaurant: {}
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    deleteZone (zone) {
      if (confirm('Вы действительно хотите удалить зону?')) {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('zone_id', zone.id)
        axios.post('https://lk.when-hungry.com/mobile/delete-zone',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(() => {
          this.table.destroy()
          this.zones.splice(this.zones.indexOf(zone), 1)
          setTimeout(() => {
            alert('Зона удалена')
          }, 1)
        })
      }
    },
    exportMap () {
      var formData = new FormData()
      var newCoordinatesPoly = []
      if (this.newPoly && this.newPoly.getMap() && (this.newPoly.type === 'polygon' || !this.newPoly.type)) {
        var coordinatesPoly = this.newPoly.getPath().getArray()
        for (var i = 0; i < coordinatesPoly.length; i++) {
          newCoordinatesPoly.push([coordinatesPoly[i].lat(), coordinatesPoly[i].lng()])
        }
        formData.append('poly', JSON.stringify(newCoordinatesPoly))
      } else if (this.newPoly && this.newPoly.getMap() && this.newPoly.type === 'circle') {
        // formData.append('coord', this.newPoly.getCenter().lng() + ',' + this.newPoly.getCenter().lat())
        // formData.append('radius', this.newPoly.getRadius())
        var lat = this.newPoly.getCenter().lat()
        var lng = this.newPoly.getCenter().lng()
        var firstradius = this.newPoly.getRadius()
        var secondradius = this.newPoly.getRadius()

        var center = new google.maps.LatLng(lat, lng)
        var center1 = new google.maps.LatLng(lat + 0.1, lng)
        var center2 = new google.maps.LatLng(lat, lng + 0.1)
        var latConv = google.maps.geometry.spherical.computeDistanceBetween(center, center1) * 10
        var lngConv = google.maps.geometry.spherical.computeDistanceBetween(center, center2) * 10
        var points = []
        var Angle
        for (Angle = 0; Angle < 360; Angle++) {
          var x = lat + ((firstradius * Math.cos(Angle * (Math.PI / 180))) / latConv)
          var y = lng + ((secondradius * Math.sin(Angle * (Math.PI / 180))) / lngConv)
          var point = new google.maps.LatLng(x, y)
          points.push(point)
        }
        formData.append('poly', JSON.stringify(points))
      } else if (this.newPoly && this.newPoly.getMap() && this.newPoly.type === 'rectangle') {
        formData.append('bounds', JSON.stringify(this.newPoly.getBounds().toJSON()))
      }
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('name', this.currentZone.title)
      if (this.currentZone.id) formData.append('zone_id', this.currentZone.id)
      formData.append('desc', this.currentZone.desc)
      formData.append('price', this.currentZone.price)
      formData.append('min_price', this.currentZone.min_price)
      formData.append('free_price', this.currentZone.free_price)
      formData.append('time', this.currentZone.time)
      formData.append('color', this.currentZone.color)
      axios.post('https://lk.when-hungry.com/api/zone-add',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.table.destroy()
        this.loadRest()
        setTimeout(() => {
          alert('Изменения сохранены')
        }, 1)
        this.currentZone = {}
        this.button = null
      })
    },
    setMap () {
      let self = this
      this.map = new google.maps.Map(this.$refs.map, {
        center: new google.maps.LatLng(this.restaurant.longitude, this.restaurant.latitude),
        zoom: 10,
        disableDefaultUI: true
      })
      this.marker = new google.maps.Marker({
        title: this.restaurant.name,
        position: new google.maps.LatLng(this.restaurant.longitude, this.restaurant.latitude),
        map: this.map
      })
      this.map.data.loadGeoJson('https://lk.when-hungry.com/api/get-zones-new?id=' + this.id + '&none=' + this.currentZone.id)

      this.map.data.setStyle(function (feature) {
        return ({
          fillColor: feature.getProperty('fillColor'),
          strokeColor: feature.getProperty('strokeColor'),
          strokeWeight: 2
        })
      })
      let infowindow = new google.maps.InfoWindow()
      google.maps.event.addListener(this.map, 'click', function () {
        infowindow.close()
      })
      this.map.data.addListener('click', function (event) {
        infowindow.setContent('<h3>Ресторан: ' + event.feature.getProperty('title') + '</h3><div>Стоимость доставки: ' + event.feature.getProperty('price') + ' руб</div>')
        infowindow.setPosition(event.latLng)
        // infowindow.setOptions({pixelOffset: new google.maps.Size(0, -30)})
        infowindow.open(this.map)
      })
      let selectedShape
      var polyOptions = {
        editable: true,
        draggable: true
      }
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ['circle', 'polygon', 'rectangle']
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions
      })
      this.drawingManager.setMap(this.map)

      function clearSelection () {
        if (selectedShape) {
          if (selectedShape.type !== 'marker') {
            selectedShape.setEditable(false)
          }
          selectedShape = null
        }
      }

      function setSelection (shape) {
        if (shape.type !== 'marker') {
          clearSelection()
          shape.setEditable(true)
        }
        selectedShape = shape
      }

      function deleteSelectedShape () {
        if (selectedShape) {
          selectedShape.setMap(null)
          self.drawingManager.setOptions({
            drawingControl: true
          })
        }
      }

      function addNewPolys (newPoly) {
        google.maps.event.addListener(newPoly, 'click', function () {
          setSelection(newPoly)
        })
      }

      google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function (e) {
        var newShape = e.overlay
        self.newPoly = newShape
        newShape.type = e.type
        if (e.type !== google.maps.drawing.OverlayType.MARKER) {
          self.drawingManager.setDrawingMode(null)

          self.drawingManager.setOptions({
            drawingControl: false
          })
          google.maps.event.addListener(newShape, 'click', function (e) {
            setSelection(newShape)
          })
          setSelection(newShape)
        }
      })
      google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', clearSelection)
      google.maps.event.addListener(this.map, 'click', clearSelection)
      google.maps.event.addDomListener(document.getElementById('delete-button'), 'click', deleteSelectedShape)

      if (this.currentZone.id) {
        console.log(JSON.parse(this.currentZone.coords))
        let coords = JSON.parse(this.currentZone.coords).coordinates
        /* Load Shapes that were previously saved */
        for (var inc = 0, ii = coords.length; inc < ii; inc++) {
          let coord = coords[inc]
          var newCoords = []
          for (var c = 0, cc = coord.length; c < cc; c++) {
            var point = coord[c]
            newCoords.push(new google.maps.LatLng(point[0], point[1]))
          }

          this.newPoly = new google.maps.Polygon({
            path: newCoords,
            options: {
              editable: true,
              draggable: true
            }
          })
          this.newPoly.setMap(this.map)
          addNewPolys(this.newPoly)
          this.drawingManager.setOptions({
            drawingControl: false
          })
          // google.maps.event.addListener(newPoly, "dragend", getPolygonCoords)
          // google.maps.event.addListener(newPoly, 'mouseup', getPolygonCoords)
          // google.maps.event.addListener(newPoly, 'insert_at', getPolygonCoords)
          // google.maps.event.addListener(newPoly, 'remove_at', getPolygonCoords)
          // google.maps.event.addListener(newPoly, 'dragend', getPolygonCoords)
          // google.maps.event.addListener(newPoly.getPath(), "remove_at", getPolygonCoords)
          // google.maps.event.addListener(newPoly.getPath(), 'dragend', getPolygonCoords)
        }
      }
    },
    initMap () {
      this.initAutocompleteInterval = setInterval(() => {
        if (this.$root.mapinit && typeof google !== 'undefined') {
          clearInterval(this.initAutocompleteInterval)
          this.setMap()
        }
      }, 500)
    },
    loadRest () {
      axios.get('https://lk.when-hungry.com/mobile/get-zones?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
        this.zones = response.data.zones
        this.restaurant = response.data.restaurant
      })
    }
  },
  watch: {
    'button' (val) {
      if (val === 'zone') setTimeout(() => { this.initMap() }, 300)
    },
    'currentZone.color' (val) {
      if (val && val.length > 7) this.currentZone.color = val.slice(0, 7)
    },
    id (val, oldVal) {
      if (val !== oldVal) {
        this.loadRest()
      }
    },
    zones () {
      setTimeout(() => {
        this.table = $('#posts_menu_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/zones.vue